import { Injectable } from '@angular/core';
import { Constants }                            from '../models/Constants';
// import * as angular_constants from "../../../angular.json";

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class BaseService {

    protected server_urls		    : Object;
    protected base_server_url		: string;
    //Auth
    protected login_base_url		: String;
    protected logout_base_url		: String;
    protected auth_refresh		    : String;
    protected api_base_url		    : string;
    protected errors			    : string;
    protected url_params            : Object = {};

    constructor() {
            // var all_keys = Object.keys(angular_constants.projects);
        // this.project_labels = all_keys[0];
        let project_labels      = Constants.PROJECT_LABEL;

        // var tmp                 = localStorage.getItem(project_labels + "_server_urls");
        // this.server_urls        = JSON.parse(tmp);
        this.server_urls          = Constants.SERVER_URLS;

        this.base_server_url 	= this.server_urls["server_base_url"];
        this.api_base_url 	    = this.server_urls["api_base_url"];
        this.login_base_url 	= this.server_urls["login_base_url"];
        this.logout_base_url 	= this.server_urls["logout_base_url"];
        this.auth_refresh 	    = this.server_urls["auth_refresh"];

    }

    getApiUrl() {
        return this.base_server_url + this.api_base_url;
    }
    
    buildSearchParamsFromSearch(search_obj)
    {
      var params  = search_obj.getHttpParams();
      return params;
    }
    
    buildSearchParams(search_obj , per_page = null , page_number = null, order_info = null, serialize_filter = {})
    {
        var params  = search_obj.getHttpParams();
        params      = params.set("serialize_filter",JSON.stringify(serialize_filter));
        if (per_page !== null && page_number !== null)
        {
          params = params.set("per_page",per_page);
          params = params.set("page_number",page_number);
        }
        if (order_info !== null && order_info["ob"] !== undefined && order_info["ov"] !== undefined)
        {
          params = params.set("ob" ,order_info["ob"]);
          params = params.set("ov" ,order_info["ov"]);    
        }
        return params;
    }

}
